'use strict';

var ResourceFactory = require('../Factory');
var Validate = require('../../core').Validate;

var definition = {
  name: 'Plan',
  basePath: ':basePath',
  endpoint: 'plans',
  debug: false,
  methods: null,
  relations : {
    // Relations are intentionally not created for 2 reasons:
    //  - Users need to be handled manually, since not all records
    //    have all permissions depending on the access level for the admin,
    //    only exposed through a special endpoint
    //  - Sites are not a direct relationship but a calculated one based on the
    //    users
  }
};

var PlanResource = function(DS) {
  var resourceFactory = new ResourceFactory(DS);

  this.initialize = function (options) {
    var resourceOptions = getResourceOptions(options);
    return resourceFactory.createResource(resourceOptions);
  };
};

var getResourceOptions = function(options) {

  Validate.exists(options, 'fbBaseUri');
  Validate.exists(options, 'fbAuthToken');

  return {
    name : 'Plan',
    apiBaseUri: options.apiBaseUri,
    collectionMethods: {
    },

    modelMethods: {
    },

    // definition formatted and passed to js-data DS
    definition: {
      format: definition,
      params: {
        basePath: options.apiBaseUri
      }
    },

    syncTriggers: {}
  };
};

module.exports = PlanResource;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/plan/PlanResource.js